import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/finance/payments-expenses',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/finance/type-expense/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/finance/payments-expenses/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/finance/payments-expenses',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/finance/payments-expenses/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/finance/payments-expenses/${id}`,
      method: 'delete',
  })
}
